import { alpha, styled } from '@mui/material';
import { Typography, Button, Image } from 'core/common/ui/ui-kit';

export const WrapperStyled = styled('div')`
  position: relative;
  padding: 20px 6px;
  border-radius: 20px;
  background: ${({ theme }) => theme.palette.contentBlockBackground.main};

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    padding: 20px 12px;
  }
`;

export const UserInfoBlockStyled = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px 20px;
  border-radius: 20px;
  background: ${({ theme }) => theme.palette.contentBlockBackground.secondary};
`;

export const TitleStyled = styled(Typography)`
  margin-bottom: 20px;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 20px;
  }
`;

export const ZodiacImageBlockStyled = styled('div')`
  flex: 1;
  text-align: center;
`;

export const ZodiacImageStyled = styled(Image)``;

export const LogoImageBlockStyled = styled('div')`
  flex: 1 1 0%;
  text-align: center;
`;

export const LogoImageStyled = styled(Image)`
  max-height: 140px;
`;

export const ContentBlockStyled = styled('div')``;

export const ContentTitleStyled = styled(Typography)`
  margin-bottom: 13px;
  text-align: center;
`;

export const ContentTextStyled = styled(Typography)`
  display: inline;
`;

export const NumberedListStyled = styled('ol')`
  margin-bottom: 20px;
  counter-reset: item;
  list-style: none;

  & > li::before {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.main};
    content: counter(item) '. ';
    counter-increment: item;
  }
`;

export const ItemStyled = styled('li')``;

export const BlurOuterContainerStyled = styled('div')`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  padding-top: 34px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0)} 0%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0.8)} 22%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0.9)} 43%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0.9)} 75%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 1)} 89%
  );
`;

export const BlurInnerContainerStyled = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  height: 100%;
  padding-bottom: 48px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0)} 0%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0.18)} 22%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0.16)} 43%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0.14)} 75%,
    ${({ theme }) => alpha(theme.palette.contentBlockBackground.main, 0.2)} 89%
  );
  backdrop-filter: blur(1.5px);
`;

export const AccessDescriptionStyled = styled(Typography)`
  max-width: 360px;
  margin-right: auto;
  margin-bottom: 28px;
  margin-left: auto;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.accent};
`;

export const ButtonStyled = styled(Button)`
  width: 100%;
  max-width: 330px;
`;
